import { FC, ReactElement } from 'react';
import Stack from '@mui/material/Stack';

// Components
import MapleCard from 'Components/ds/MapleCard';
import MapleCardContent from 'Components/ds/MapleCardContent';
import Typography from 'Components/ds/Typography';
import Stat from 'Components/ds/Stat';

interface FeatureProps {
  title: string;
  content: string | ReactElement;
  icon: ReactElement;
}

const Feature: FC<FeatureProps> = ({ title, content, icon }: FeatureProps): ReactElement => {
  return (
    <MapleCard sx={{ width: { xs: '100%', md: '50%' } }}>
      <MapleCardContent>
        <Stack direction='column' spacing={2.5}>
          <Stat value={title} icon={icon} />
          {typeof content === 'string' ? <Typography color='ds.neutral.400'>{content}</Typography> : content}
        </Stack>
      </MapleCardContent>
    </MapleCard>
  );
};

export default Feature;
